import { c as _c } from "react/compiler-runtime";
import { CiBoxList } from 'react-icons/ci';
import { FiEdit3, FiLogOut } from 'react-icons/fi';
import { HiCheck, HiChevronDoubleRight, HiChevronDown, HiMagnifyingGlass, HiMinus, HiOutlineHome, HiOutlineMapPin, HiOutlineTrash, HiPlus, HiXMark } from 'react-icons/hi2';
import { IoNotificationsOffOutline, IoNotificationsOutline } from 'react-icons/io5';
import { MdHistory, MdOutlineTipsAndUpdates, MdSend } from 'react-icons/md';
import { PiSparkleLight } from 'react-icons/pi';
import { RiSparkling2Line } from 'react-icons/ri';
import { RxOpenInNewWindow } from 'react-icons/rx';
import { VscHeart, VscHeartFilled } from 'react-icons/vsc';
import { twMerge } from 'tailwind-merge';
export namespace CruzIcon {
  export const PriceDrop = t0 => {
    const $ = _c(6);
    const {
      className
    } = t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <title>Price Drop</title>;
      t2 = <g id="SVGRepo_bgCarrier" strokeWidth="0" />;
      t3 = <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />;
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
    } else {
      t1 = $[0];
      t2 = $[1];
      t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <g id="SVGRepo_iconCarrier"><path d="m13.842 11.52-4.389 4.388a1.112 1.112 0 0 1-1.567 0l-6.28-6.28a3.027 3.027 0 0 1-.771-1.892l.043-3.681A1.141 1.141 0 0 1 2 2.935L5.67 2.9a3.04 3.04 0 0 1 1.892.773l6.28 6.28a1.112 1.112 0 0 1 0 1.567zM3.826 5.133a.792.792 0 1 0-.792.792.792.792 0 0 0 .792-.792zm6.594 7.348a.554.554 0 0 0 0-.784l-.401-.401a2.53 2.53 0 0 0 .35-.83 1.565 1.565 0 0 0-.397-1.503 1.59 1.59 0 0 0-1.017-.46 2.14 2.14 0 0 0-.75.085h-.002a2.444 2.444 0 0 0-.59.277H7.61a2.677 2.677 0 0 0-.438.357 2.043 2.043 0 0 1-.259.22 1.29 1.29 0 0 1-.329.17h-.002a.835.835 0 0 1-.338.038h-.002a.53.53 0 0 1-.314-.136.539.539 0 0 1-.106-.534 1.54 1.54 0 0 1 .41-.71 1.632 1.632 0 0 1 .23-.165l.03-.019a1.783 1.783 0 0 1 .322-.155.942.942 0 0 1 .325-.06.554.554 0 0 0 0-1.108h-.001a2.058 2.058 0 0 0-.717.132 2.846 2.846 0 0 0-.529.26l-.01.006-.398-.4a.554.554 0 1 0-.784.785l.388.387a2.513 2.513 0 0 0-.347.803 1.644 1.644 0 0 0 .404 1.561 1.622 1.622 0 0 0 .983.456 1.922 1.922 0 0 0 .805-.089 2.372 2.372 0 0 0 .624-.319 3.142 3.142 0 0 0 .398-.339 1.569 1.569 0 0 1 .256-.208 1.381 1.381 0 0 1 .32-.151 1.023 1.023 0 0 1 .348-.038.485.485 0 0 1 .308.139c.05.049.165.165.097.488a1.558 1.558 0 0 1-.413.729 2.476 2.476 0 0 1-.28.219 1.727 1.727 0 0 1-.306.157.687.687 0 0 1-.32.042.554.554 0 1 0-.08 1.106c.052.004.103.005.152.005a1.723 1.723 0 0 0 .685-.134 2.678 2.678 0 0 0 .507-.27l.01-.007.397.398a.555.555 0 0 0 .783 0z" /></g>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== className) {
      t5 = <svg fill="currentColor" className={className} viewBox="-2 0 19 19" xmlns="http://www.w3.org/2000/svg">{t1}{t2}{t3}{t4}</svg>;
      $[4] = className;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  };
  const iconStyle = 'size-4 min-w-4';
  export const Home = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <HiOutlineHome className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Open = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <RxOpenInNewWindow className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const MapPin = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <HiOutlineMapPin className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const ChevronDoubleRight = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <HiChevronDoubleRight className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const History = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <MdHistory className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const List = t0 => {
    const $ = _c(5);
    const {
      className,
      title
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = title || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
      t3 = <CiBoxList className={t1} title={t2} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Heart = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Heart" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <VscHeart className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const HeartFilled = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Heart Filled" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <VscHeartFilled className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const LogOut = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Log Out" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <FiLogOut className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const NotificationOn = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Notifications On" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <IoNotificationsOutline className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const NotificationOff = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Notifications Off" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <IoNotificationsOffOutline className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Down = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Down" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiChevronDown className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Tips = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Tips" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge("size-5 min-w-5 text-yellow-500", className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <MdOutlineTipsAndUpdates className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Send = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Send" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <MdSend className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Close = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Close" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiXMark className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Edit = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Edit" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <FiEdit3 className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Trash = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Trash" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiOutlineTrash className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Search = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Search" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiMagnifyingGlass className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Plus = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Plus" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiPlus className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Minus = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Minus" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiMinus className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Check = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "Check" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <HiCheck className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Ai = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "AI" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <RiSparkling2Line className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const AiLight = t0 => {
    const $ = _c(5);
    const {
      className,
      title: t1
    } = t0;
    const title = t1 === undefined ? "AI" : t1;
    let t2;
    if ($[0] !== className) {
      t2 = twMerge(iconStyle, className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2 || $[3] !== title) {
      t3 = <PiSparkleLight className={t2} title={title} />;
      $[2] = t2;
      $[3] = title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  };
  export const Spin = t0 => {
    const $ = _c(7);
    const {
      className
    } = t0;
    let t1;
    if ($[0] !== className) {
      t1 = twMerge("size-5 animate-spin text-red-800", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <title>Loading</title>;
      t3 = <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />;
      t4 = <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />;
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
    } else {
      t2 = $[2];
      t3 = $[3];
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t1) {
      t5 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">{t2}{t3}{t4}</svg>;
      $[5] = t1;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  };
}